import { render, staticRenderFns } from "./contest.vue?vue&type=template&id=2065e491&scoped=true&"
import script from "./contest.vue?vue&type=script&lang=js&"
export * from "./contest.vue?vue&type=script&lang=js&"
import style0 from "./contest.vue?vue&type=style&index=0&id=2065e491&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065e491",
  null
  
)

export default component.exports